export default __webpack_public_path__ + "static/dev-nashville-bbe3a4e23919f7d0e21bc451836e1fd5.jpg";